<template>
  <div id="salesmanList" v-loading="exportLoading">
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="160">
      <FormItem class="form_item" :label="$t('projectName1')">
        <Input clearable v-model="projectName" :placeholder="$t('enter')"/>
      </FormItem>
      <!-- <FormItem class="form_item" :label="$t('projectNumber1')">
        <Input clearable v-model="projectNumber" :placeholder="$t('enter')"/>
      </FormItem> -->
      <FormItem class="form_item" :label="$t('projectID')">
        <Input clearable v-model="upstreamSystemId" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('serviceContractNo2')">
        <Input clearable v-model="serviceContractNo" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('country1')">
        <el-select filterable v-model="country" clearable :placeholder="$t('select')">
          <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('customerName1')">
        <Input clearable v-model="customerName" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('projectManager1')" v-if="queryShow">
        <el-select v-model="projectManager" clearable filterable remote :remote-method="remoteMethod" :placeholder="$t('select')">
          <el-option v-for="(item, index) in ProjectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('projectStatus1')" v-if="queryShow">
        <el-select v-model="projectStatus" clearable>
          <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('projectStartDate1')" v-if="queryShow">
        <el-date-picker v-model="projectStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('projectEndDate1')" v-if="queryShow">
        <el-date-picker v-model="projectEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('finalBeneficialDept1')" v-if="queryShow">
        <el-select v-model="finalBeneficialDept" clearable filterable remote :remote-method="value => remoteMethodDept('FinalBeneficialDeptList', value)">
          <el-option v-for="(item, index) in FinalBeneficialDeptList" :key="index" :label="item.deptEnName" :value="item.deptEnName"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('csiAccountCode1')" v-if="queryShow">
        <Input clearable v-model="csiAccountCode" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('beltAndRoad1')" v-if="queryShow">
        <el-select v-model="beltAndRoad" clearable>
          <el-option v-for="item in BeltAndRoadList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('department1')" v-if="queryShow">
        <el-select filterable v-model="department" clearable>
          <el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
        </el-select>
      </FormItem>
      <!-- <FormItem class="form_item" :label="$t('upstreamSystemId1')" v-if="queryShow">
        <Input clearable v-model="upstreamSystemId" :placeholder="$t('enter')"/>
      </FormItem> -->
      <div class="buttonDiv">
        <el-button type="primary" size="mini" @click="advancedFilter">{{$t('advancedFilter')}}</el-button>
        <el-button type="primary" size="mini" @click="searchProjectByPage">{{$t('search')}}</el-button>
        <el-button type="primary" size="mini" @click="chooseInfo">{{$t('addToProject')}}</el-button>
        <el-button type="primary" size="mini" @click="returnList">{{$t('return')}}</el-button>
      </div>
    </Form>
    <div class="contentTableDiv">
         <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="id" v-if="false"></el-table-column> 
            <!-- <el-table-column prop="projectNumber" :label="$t('projectNumber')" align="center" width="170" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.projectNumber}}</a>
              </template>
            </el-table-column> -->
            <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="280"></el-table-column>
            <el-table-column prop="projectType" :label="$t('projectType')" align="center" :show-overflow-tooltip="true" min-width="200"></el-table-column>
            <el-table-column prop="projectStatus" :label="$t('projectStatus')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
            <el-table-column prop="projectManager" :label="$t('projectManager')" align="center" :show-overflow-tooltip="true" min-width="160"></el-table-column>
            <!-- <el-table-column prop="upstreamSystemId" :label="$t('upstreamSystemId')" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="serviceContractNo" :label="$t('serviceContractNo')" align="center" :show-overflow-tooltip="true"></el-table-column> -->
            <el-table-column prop="country" :label="$t('country')" align="center" :show-overflow-tooltip="true" min-width="100"></el-table-column>
            <el-table-column prop="projectStartDate" :label="$t('projectStartDate')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
            <el-table-column prop="projectEndDate" :label="$t('projectEndDate')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
        </el-table> 
    </div>
    
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
         :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>

  </div>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'

    export default {
        name: 'ipmsSource',
        created () {
          this.getProjectByPage();
          this.getCountry();
          this.getDeptList();
        },
        data () {
          return {
            rangeNumber: 10,
            projectName:null,
            projectNumber:null,
            serviceContractNo:null,
            projectType:null,
            country:null,
            customerName:null,
            projectManager:null,
            projectStatus:null,
            projectStartDate:null,
            projectEndDate:null,
            finalBeneficialDept:null,
            csiAccountCode:null,
            beltAndRoad:null,
            department:null,
            upstreamSystemId:null,
            projectId:null,
            pjNumber:null,
            BeltAndRoadList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'PartialDelivery',label: 'Partially delivered'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            ProjectManagerList:[],
            DeptList:[],
            FinalBeneficialDeptList:[],
            queryShow:false,
            exportLoading:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            tableData: [],
            CountryList:[],
          }
        },
        methods: {
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptCodechain: 'SelectDept',
            }
            this._post(url,pm).then(
              res => {   
                this.DeptList = res.data;
              }
            )
          },
          remoteMethodDept(list, query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchDeptOptions(list, query)
              }, 200)
            } else {
              this[list] = [];
            }
          },
          fetchDeptOptions(list, query) {
            let url =`${this.$store.state.islhurl}dept/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this[list] = res.data;
              } else {
                this[list] = [];
              }
            }).catch(error => {
              this[list] = [];
              console.error('搜索失败:', error)
            })
          },
          getProjectTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'ProjectType',
            }
            this._post(url,pm).then(
              res =>{
                this.ProjectTypeList = res.data;
              }
            )
          },
          getProjectByPage(){
            let url = `${this.$store.state.islhurl}getSourceInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectName: this.projectName==''?null:this.projectName,
              projectNumber: this.projectNumber==''?null:this.projectNumber,
              projectType: this.projectType==''?null:this.projectType,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              country: this.country==''?null:this.country,
              customerName: this.customerName==''?null:this.customerName,
              projectManager: this.projectManager==''?null:this.projectManager,
              projectStatus: this.projectStatus==''?null:this.projectStatus,
              projectStartDate: this.projectStartDate==''?null:this.projectStartDate,
              projectEndDate: this.projectEndDate==''?null:this.projectEndDate,
              finalBeneficialDept: this.finalBeneficialDept==''?null:this.finalBeneficialDept,
              csiAccountCode: this.csiAccountCode==''?null:this.csiAccountCode,
              beltAndRoad: this.beltAndRoad==''?null:this.beltAndRoad,
              department: this.department==''?null:this.department,
              upstreamSystemId : this.upstreamSystemId==''?null:this.upstreamSystemId,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          searchProjectByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let url = `${this.$store.state.islhurl}getSourceInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectName: this.projectName==''?null:this.projectName,
              projectNumber: this.projectNumber==''?null:this.projectNumber,
              projectType: this.projectType==''?null:this.projectType,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              country: this.country==''?null:this.country,
              customerName: this.customerName==''?null:this.customerName,
              projectManager: this.projectManager==''?null:this.projectManager,
              projectStatus: this.projectStatus==''?null:this.projectStatus,
              projectStartDate: this.projectStartDate==''?null:this.projectStartDate,
              projectEndDate: this.projectEndDate==''?null:this.projectEndDate,
              finalBeneficialDept: this.finalBeneficialDept==''?null:this.finalBeneficialDept,
              csiAccountCode: this.csiAccountCode==''?null:this.csiAccountCode,
              beltAndRoad: this.beltAndRoad==''?null:this.beltAndRoad,
              department: this.department==''?null:this.department,
              upstreamSystemId : this.upstreamSystemId==''?null:this.upstreamSystemId,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          returnList(){
            this.$router.push({path:'/project'})
            this.$store.commit('tagChange', 'project');
          },
          handleNavigation(index){
            let pm = {
              id: index.id,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              projectName: this.projectName,
              projectNumber: this.projectNumber,
              projectType: this.projectType,
              serviceContractNo: this.serviceContractNom,
              country: this.country,
              customerName: this.customerName,
              projectManager: this.projectManager,
              projectStatus: this.projectStatus,
              projectStartDate: this.projectStartDate,
              projectEndDate: this.projectEndDate,
              finalBeneficialDept: this.finalBeneficialDept,
              csiAccountCode: this.csiAccountCode,
              beltAndRoad: this.beltAndRoad,
              department: this.department,
              upstreamSystemId : this.upstreamSystemId,
            }
            this.$router.push({name:'project_detail',params:pm})
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          chooseInfo(){
            const length = this.multipleSelection.length;
            if(length == 0){
              this.$message.warning('Please choose the project first！');
              return;
            }
            this.$confirm("Are you sure to add the project", "Warning", {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              let ids = [];
              for (let i = 0; i < length; i++) {
                ids.push(this.multipleSelection[i].id)
              }
              let params = {
                ids : ids,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}project/addToPond`
              this._post(url,params).then(
                res =>{
                  if(res=="200"){
                    this.getProjectByPage();
                    this.$Message.success('Project Add Successful' )
                  }else{
                    this.$message.error(res);
                  }
                }
              )
            }).catch(() => {
            });
          },
          advancedFilter(){
            if(this.queryShow){
              this.queryShow = false;
              this.projectManager = null;
              this.projectStatus = null;
              this.projectStartDate = null;
              this.projectEndDate = null;
              this.finalBeneficialDept = null;
              this.csiAccountCode = null;
              this.beltAndRoad = null;
              this.department = null;
              this.upstreamSystemId = null;
            }else{
              this.queryShow = true;
            }
          },
          changePage (val) {
            this.currentPage = val;
            this.getProjectByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getProjectByPage();
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          //远程搜索方法
          remoteMethod(query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(query)
              }, 200)
            } else {
              this.ProjectManagerList = [];
            }
          },
          fetchUserOptions(query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this.ProjectManagerList = res.data;
              } else {
                this.ProjectManagerList = [];
              }
            }).catch(error => {
              this.ProjectManagerList = [];
              console.error('搜索失败:', error)
            })
          },
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/project/sourceList.vue